export default '/portal'



// WEBPACK FOOTER //
// ./src/api/prefix.js